module.exports = __webpack_public_path__ + "img/image-4.352fec52.webp";